import React from 'react'
import { connect } from 'react-redux'
import toJS from '../../../containers/general/toJS'
import printConfig from '../../../print-config.json'
import ChoosePrintFormat from '../present/ChoosePrintFormat';
import getData from '../../../functions/getData';
import { PRINT_WEEKS } from '../../../constants/state';
import { generatePath } from 'react-router-dom';
import getCurrentWeek from '../../../functions/getCurrentWeek';

const mapStateToProps = (state) => ({
    weeks: getData(state, PRINT_WEEKS)
})

const ChoosePrintFormatContainer = ({
    match,
    weeks, 
    goBackPath
}) => {
    const { printType } = match.params
    const { transIdname, formats } = printConfig.routes[printType]
    const closePagePath = generatePath(goBackPath, match.params)
    const currentWeek = getCurrentWeek(weeks)

    return <ChoosePrintFormat 
        transIdname={transIdname} 
        formats={formats}
        printType={printType}
        week={currentWeek}
        basicUrl={match.url}
        closePagePath={closePagePath}
    />
}

export default connect(mapStateToProps, () => ({}))(toJS(ChoosePrintFormatContainer))